import { render, staticRenderFns } from "./NotificationNeuerMangel.vue?vue&type=template&id=4af55854"
import script from "./NotificationNeuerMangel.vue?vue&type=script&lang=js"
export * from "./NotificationNeuerMangel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports